export default "__VITE_ASSET__CaAhz_1J__"